import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import ImageUploadWithCrop from "../../CoreComponents/ImageUploadWithCrop";
import { createBanner, updateBanner } from "./api";
import { chosenLink, linkOf, missingChoice, sameLink, startingChoice } from "./bannerLink";
import LinkPicker from "./LinkPicker";
import { notify } from "./notify";
import { pictureSpec, placementById } from "./placements";

export default function BannerForm({ open, onClose, onSaved, placement, sectionId, banner, franchiseId }) {
  const spec = pictureSpec(placementById(placement).shape);
  const [picture, setPicture] = useState("");
  const [choice, setChoice] = useState(startingChoice(null));
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    setPicture(banner ? banner.image || "" : "");
    setChoice(startingChoice(banner));
  }, [open, banner]);

  const save = async () => {
    const problem = !picture ? "Add a picture" : missingChoice(choice);
    if (problem) return notify({ Status: false, Error: problem });
    setSaving(true);
    const link = chosenLink(choice);
    const result = banner
      ? await updateBanner(banner.id, {
          picture: typeof picture === "string" ? undefined : picture,
          link: sameLink(link, linkOf(banner)) ? undefined : link,
        })
      : await createBanner({ placement, sectionId, picture, link, franchiseId });
    setSaving(false);
    if (notify(result, banner ? "Banner saved" : "Banner added")) onSaved();
  };

  return (
    <Modal open={open} title={banner ? "Edit banner" : "Add banner"} okText="Save" onOk={save}
      confirmLoading={saving} onCancel={onClose} destroyOnClose>
      <ImageUploadWithCrop label="Picture" value={picture} onChange={(file) => setPicture(file || "")}
        {...spec} required />
      <LinkPicker open={open} franchiseId={franchiseId} value={choice} onChange={setChoice} />
    </Modal>
  );
}
